// Browo-Dev-Deployment (off-prod). Original-Prod-Werte:
//   apiUrl: https://api.halteverbot123.de/api/ | hostUrl: https://www.halteverbot123.de | paypalPlusMode: live
// Cutover 02.09.2026: EIN Build fuer BEIDE Domains — zur Laufzeit nach Host
// entschieden. Auf der echten Domain gelten die Original-Prod-Werte (PayPal
// LIVE!), auf der browo.ai-Testdomain weiter Sandbox + Test-API. Ohne diese
// Weiche haette der Testbuild nach dem DNS-Umzug Kundenzahlungen in die
// PayPal-Sandbox geschickt.
const aufEchterDomain =
  typeof window !== 'undefined' && /(^|\.)halteverbot123\.de$/.test(window.location.hostname);
const production = aufEchterDomain
  ? {
      apiUrl: 'https://api.halteverbot123.de/api/',
      hostUrl: 'https://www.halteverbot123.de',
      redirectUrl: 'https://www.halteverbot123.de/index.html',
      paypalPlusMode: 'live',
    }
  : {
      apiUrl: 'https://halteverbot123-api.browo.ai/api/',
      hostUrl: 'https://halteverbot123.browo.ai',
      redirectUrl: 'https://halteverbot123.browo.ai/index.html',
      paypalPlusMode: 'sandbox',
    };


const test = {};

const local = {
  apiUrl: 'http://localhost:8081/api/',
  hostUrl: 'http://localhost:8080',
  redirectUrl: 'http://localhost:8080/index.html',
  paypalPlusMode: 'sandbox'
};

let globalConfig = null;

const config = () => {
  if (globalConfig) return globalConfig;

  if (process.env.NODE_ENV === 'production') {
    globalConfig = production;
  } else if (process.env.NODE_ENV === 'test') {
    globalConfig = Object.assign(production, test);
  } else {
    globalConfig = Object.assign(production, test, local);
  }

  return globalConfig;
};

export default config();
